import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useMemo, useRef, } from 'react';
export const ScrollToExpandedContext = createContext(undefined);
export const ScrollToExpandedProvider = ({ scrollTargetId, children, }) => {
    const hasScrolledRef = useRef(false);
    const notifyContentReady = useCallback(() => {
        const shouldSkipScroll = !scrollTargetId || hasScrolledRef.current;
        if (shouldSkipScroll)
            return;
        hasScrolledRef.current = true;
        requestAnimationFrame(() => {
            document
                .getElementById(scrollTargetId)
                ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }, [scrollTargetId]);
    const value = useMemo(() => ({ notifyContentReady }), [notifyContentReady]);
    return (_jsx(ScrollToExpandedContext.Provider, { value: value, children: children }));
};
